﻿import { Directive } from "@app/components/directive";
import { NgComponent } from "@app/di/decorators";
import { Token } from "@app/di/token";
import { Dirs } from "@app/helpers/dirs";

interface IActionSelectScope extends ng.IScope {
    source: any;
    defaultLabel: string;
    onAction: (value: string) => {};
    _actionSelect: any;
}

@NgComponent({
    token: Token.KbActionSelect,
    dependencies: [
        Token.$Q,
        Token.$Http,
    ]
})
export class KbActionSelect extends Directive {

    constructor(
        $q: ng.IQService,
        $http: ng.IHttpService
    ) {

        super();

        this.restrict = "EA";
        this.template = Dirs.component("kb-action-select");
        this.scope = {
            source: "=",
            valueField: "@",
            defaultLabel: "@",
            icon: "@",
            onAction: "="
        };
        this.replace = true;

        this.link = (scope: IActionSelectScope, element: JQuery, atts, ngModel: ng.INgModelController) => {
            scope._actionSelect = "";

            scope.$watch("_actionSelect", (newValue: string) => {
                if (!newValue) return;
                scope.onAction(newValue);
                scope._actionSelect = "";
            });
        };
    }
}
